import React from "react";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";
import { DataRequestStateEnum } from "@/core/types/dataRequestsTypes";

type PaginationProps = {
  loadMore: () => void;
  requestState?: DataRequestStateEnum;
};

export const Pagination: React.FC<PaginationProps> = ({ loadMore, requestState }) => {
  return (
    <div className="mx-auto w-full pb-[16px] pt-[24px]">
      <BaseButton
        component="button"
        onClick={loadMore}
        title="Zobrazit další"
        type={ButtonType.Primary}
        fullWidth
        small
        isLoading={
          requestState &&
          (requestState === DataRequestStateEnum.PENDING || requestState === DataRequestStateEnum.RUNNING)
        }
      />

      <div className="mt-[24px] lg:mt-[16px]">
        <BaseButton href="#" title="Nahoru" type={ButtonType.Transparent} fullWidth small hasUpChevron />
      </div>
    </div>
  );
};
